import api, { apiForRefresh } from 'src/config/api';
import { Instance } from 'src/types/instance';
import {
  LoginData,
  AzureLoginData,
  OktaLoginData,
  MeResponse,
  UpdatePasswordWithCodeData,
  GoogleLoginData,
  LoginInstance,
  OTP,
  SendOTPData,
  LoginOTPData,
  AuthResponse,
} from 'src/types/login';

export const getInstances = (username: string) =>
  api.get<LoginInstance[]>('auth/instances', { params: { username } });

export const getOTP = (instanceId: number, employeeInternalId: string) =>
  api.get<OTP[]>('auth/otp', {
    params: {
      instanceId,
      employeeInternalId,
    },
  });

export const sendOTP = (sendOTPData: SendOTPData) =>
  api.post('auth/otp/send', sendOTPData);

export const loginOTP = (loginOTPData: LoginOTPData) =>
  api.post<AuthResponse>('auth/otp/login', loginOTPData);

export const login = (loginData: LoginData) =>
  api.post<AuthResponse>('auth/login', loginData);

export const logout = () => api.post('auth/logout');

export const authRefresh = () =>
  apiForRefresh.get<AuthResponse>('/auth/refresh');

export const getChildSessions = refreshToken =>
  api.post<AuthResponse>(
    '/auth/sessions/child',
    {},
    {
      headers: { Authorization: `Bearer ${refreshToken}` },
    },
  );

export const getMe = () => api.get<MeResponse>('users/me');

export const tokenLogin = () => api.post<AuthResponse>('users/token-login');

export const azureLogin = (loginData: AzureLoginData) =>
  api.post<AuthResponse>('auth/azure-sso/login', loginData);

export const getAzureInstances = (accessToken: string) =>
  api.post<LoginInstance[]>('auth/azure-sso/instances', { accessToken });

export const oktaLogin = (loginData: OktaLoginData) =>
  api.post<AuthResponse>('auth/okta-sso/login', loginData);

export const getOktaInstances = (accessToken: string) =>
  api.post<LoginInstance[]>('auth/okta-sso/instances', { accessToken });

export const getGoogleInstances = (code: string) =>
  api.post<LoginInstance[]>('auth/google-sso/instances', { accessToken: code });

export const googleLogin = (loginData: GoogleLoginData) =>
  api.post<AuthResponse>('auth/google-sso/login', {
    instanceId: loginData.instanceId,
    accessToken: loginData.accessToken,
  });

export const resetPassword = (employeeInternalId, instanceId) =>
  api.post('auth/reset-password', { employeeInternalId, instanceId });

export const updatePassword = (id, newPassword, token) =>
  api.post(
    `users/${id}/update-password`,
    {
      newPassword,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

export const updatePasswordWithCode = ({
  code,
  passwordInput,
}: UpdatePasswordWithCodeData) =>
  api.post('/auth/update-password', {
    code,
    newPassword: passwordInput,
  });

export const getInstanceForRestorePassword = (code: string) =>
  api.get<Instance>('instances/user-reset-code', { params: { code } });

export const getInstanceForRegisterUser = (code: string) =>
  api.get<Instance>('instances/user-code', { params: { code } });

export const getInstanceForJoinByLink = (code: string) =>
  api.get<Instance>('instances/code', { params: { code } });

export const getNewFeatures = () => api.get('/features');

export const getTermsAndConditions = () => api.get('/terms-and-conditions');

export const acceptTermsAndConditions = id =>
  api.post(`/terms-and-conditions/${id}/acceptance`);
